import { GroupAssign, Model,Location,CIDMGroup, MembershipType } from "../../booking-table/CustomCells";
import Actions from "./Actions";
import DATA_LABEL_TABLE from "../../../../utils/constants/dataLabelTable";

export const GroupTableMeta = {
  fields: {
    equipmentModel: {
      component: Model,
      text: 'Model',
      headProps: {
        style: {
          flex: "0 1 20%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 20%",
        },
      },
    },
    location: {
      component: Location,
      text: "Location",
      headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
        },
      },
    },
    membership: {
      component: MembershipType,
      text: "Membership type",
      headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
        },
      },  
    },
    cidm: {
      component: CIDMGroup,
      text: "CIDM Group",
      headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 500,
          whiteSpace: "nowrap",
          paddingRight: 15,
        },
      },
    },
    users: {
      component: GroupAssign,
      text: DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.users,
      headProps: {
        style: {
          flex: "0 1 20%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 20%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 500,
          whiteSpace: "nowrap",
          paddingRight: 15,
        },
      },
    },
    groupName: {
      text: DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.booking_group,
      headProps: {
        style: {
          flex: "0 1 20%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 20%",
        },
      },
    },
    action: {
      component: Actions,
      headProps: {
        style: {
          flex: "0 1 10%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 10%",
        },
      },
    },
  },
};

export default GroupTableMeta;
